import { jsx as _jsx } from "react/jsx-runtime";
import clsx from 'clsx';
export const FormActions = props => {
    const { children, className, ...rest } = props;
    return (_jsx("div", { className: clsx('flex flex-row-reverse space-x-2 space-x-reverse', className), ...rest, children: children }, void 0));
};
//# sourceMappingURL=Actions.js.map